import { FluxStandardAction } from 'flux-standard-action'
import { HEADER_TITLES } from '../constants/header.constant'
export const setPage = (page: string): FluxStandardAction<any, any> => ({
  type: page,
  payload: HEADER_TITLES[page],
  meta: null,
})



// WEBPACK FOOTER //
// ./src/actions/header.action.ts